import * as Yup from "yup";
const VALIDATE_MESSAGE = {
  required: "Thông tin bắt buộc"
};

export const ValidateSchemaUpdate = Yup.object().shape({
  userName: Yup.string()
    .nullable()
    .required(VALIDATE_MESSAGE.required),
  fullName: Yup.string()
    .nullable()
    .required(VALIDATE_MESSAGE.required),
  email: Yup.string()
    .nullable()
    .email("Email không hợp lệ")
    .required(VALIDATE_MESSAGE.required),
  roles: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.string()
          .nullable()
          .required(VALIDATE_MESSAGE.required)
      })
    )
    .min(1, VALIDATE_MESSAGE.required)
});

export const ValidateSchemaAdd = Yup.object().shape({
  userName: Yup.string()
    .nullable()
    .required(VALIDATE_MESSAGE.required),
  fullName: Yup.string()
    .nullable()
    .required(VALIDATE_MESSAGE.required),
  email: Yup.string()
    .nullable()
    .email("Email không hợp lệ")
    .required(VALIDATE_MESSAGE.required),
  password: Yup.string()
    .nullable()
    .required(VALIDATE_MESSAGE.required)
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{6,}$/,
      "Mật khẩu phải có ít nhất 6 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt"
    ),
  roles: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.string()
          .nullable()
          .required(VALIDATE_MESSAGE.required)
      })
    )
    .min(1, VALIDATE_MESSAGE.required)
});
